module.exports = __webpack_public_path__ + "img/img11.3988aedb.png";